
<ngb-rating [(rate)]="rateStar" [readonly]="true" [max]="3">
    <ng-template let-fill="fill" let-index="index">
        <span class="star" [class.full]="fill === 100">
            <span class="half" [style.width.%]="fill"><i class="far fa-star star_icon" aria-hidden="true"></i></span><i class="far fa-star star_icon" aria-hidden="true"></i>
        </span>
    </ng-template>
</ngb-rating>
